<template>
  <div v-if="statusPage.active" class="max-w-7xl mx-auto sm:px-6 py-6 px-8">

    <ul class="grid grid-cols-1 gap-6 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3">
      <li class="col-span-1 lg:col-start-2 flex flex-col text-center bg-white rounded-lg shadow divide-y divide-gray-200">
        <div class="flex-1 flex flex-col p-8">
          <img class="w-32 h-32 flex-shrink-0 shadow-lg border-4 mx-auto rounded-full"
             :src="statusPage.image"
             alt=""
          />
          <h3 class="mt-2 text-gray-900 text-lg font-medium mb-1">{{statusPage.title}}</h3>
          <div v-if="status" class="mt-1">
            <span class="px-2 py-1 text-yellow-800 text-lg font-medium bg-yellow-100 rounded-full">Busy</span>
          </div>
          <div v-else>
            <span class="px-2 py-1 text-gray-800 text-md font-medium bg-gray-100 rounded-full">Unknown</span>
          </div>

        </div>
        <div v-if="statusPage.emergencyMessage">
          <div class="-mt-px flex divide-x divide-gray-200">
            <div class="-ml-px w-0 flex-1 flex">
              <div class="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500">
                In an emergency: {{statusPage.emergencyMessage}}
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div class="grid grid-cols-1 gap-6 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3">
      <a @click="fetchState" class="cursor-pointer col-span-1 lg:col-start-2 text-center mt-4 text-sm text-green-400">Refresh</a>
    </div>
  </div>
  <div v-else class="max-w-7xl mx-auto sm:px-6 py-6 lg:px-8">
    <div v-if="loaded">
      Status page you are looking for is either disabled or not available any more.
    </div>
  </div>
</template>

<script>
  import { useRoute } from 'vue-router';
  import { ref } from 'vue';
  import { buildEdgeFunctionUrl } from '@/helpers/edge-functions';

  export default {
    name: "Status",
    setup() {
      const route = useRoute();
      const status = ref(false);
      const statusPage = ref(false);
      const loaded = ref(false);

      return {
        route,
        status,
        statusPage,
        loaded,
      }
    },
    methods: {
      fetchState() {
        this.loaded = false;
        fetch(buildEdgeFunctionUrl('status-public', { id: this.route.params.id }), {
          method: 'POST',
        }).then(response => response.json())
        .then(data => {
          if (data.statusPage.active === false) {
            this.loaded = true;
          } else {
            this.status = data.element;
            this.statusPage = data.statusPage;
          }
        })
        .catch(() => {
          this.loaded = true;
          this.status = false;
        });
      }
    },
    mounted() {
      this.fetchState();
    }
  };
</script>
